module.exports = __webpack_public_path__ + "public/img/car.d013cb9f.png";